export const Config: any = {
    version: '1.7.24'
};

export default Config;